import { useAppShellStore } from "../../app-shell";
import { Logo } from "../../branding";
import { Button } from "../../button";
import { Icon } from "../../icons";
import { cn } from "../../utils";

export function SidebarNavigationTop() {
	/** Hooks */
	const { sidebarIsCollapsed, toggleSidebarIsCollapsed } = useAppShellStore();

	/** Render */
	return (
		<div
			className={cn(
				"py-2 border-b-[0.5px] border-color",
				sidebarIsCollapsed ? "h-stack justify-center px-2" : "h-stack justify-between px-4",
			)}
		>
			{!sidebarIsCollapsed && <Logo height="24" />}
			<Button
				onClick={toggleSidebarIsCollapsed}
				variant="ghost"
				icon={
					<Icon
						name={sidebarIsCollapsed ? "PanelLeftOpen" : "PanelLeftClose"}
						size={14}
					/>
				}
			/>
		</div>
	);
}
